export function trackAdsConversion() {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: "AW-18336889510/3kkhCNetvtMcEKb12qdE",
    value: 1.0,
    currency: "INR",
  });
}
